/** Turns the identity service's sign-in answers into outcomes the facade can act on. */
export class SignInService {
    identityClient;
    returnAddressSource;
    constructor(identityClient, returnAddressSource) {
        this.identityClient = identityClient;
        this.returnAddressSource = returnAddressSource;
    }
    async requestCode(email) {
        const result = await this.identityClient.startEmailSignIn({ email });
        return this.describeCodeRequest(result);
    }
    async checkCode(email, code) {
        const returnTo = this.returnAddressSource.getReturnAddress();
        const request = { email, code };
        if (returnTo !== undefined) {
            request.returnTo = returnTo;
        }
        const result = await this.identityClient.verifyEmailSignIn(request);
        return this.describeCodeCheck(result);
    }
    describeCodeRequest(result) {
        let codeRequest;
        if (result.success !== undefined) {
            codeRequest = { kind: 'sent', secondsUntilResend: result.success.resendAvailableInSeconds };
        }
        else if (result.tooManyRequests !== undefined) {
            codeRequest = { kind: 'too-many-codes', secondsUntilResend: result.tooManyRequests.resendAvailableInSeconds };
        }
        else {
            throw new Error('trip-os-identity gave no known answer to the sign-in code request');
        }
        return codeRequest;
    }
    describeCodeCheck(result) {
        let codeCheck;
        if (result.success !== undefined) {
            codeCheck = { kind: 'signed-in', redirectTo: result.success.redirectTo };
        }
        else if (result.unauthorized !== undefined) {
            codeCheck = this.describeRefusal(result.unauthorized);
        }
        else {
            throw new Error('trip-os-identity gave no known answer to the sign-in code check');
        }
        return codeCheck;
    }
    describeRefusal(refusal) {
        const secondsUntilResend = refusal.resendAvailableInSeconds;
        let codeCheck;
        if (refusal.reason === 'wrong-code') {
            if (refusal.attemptsLeft === undefined) {
                throw new Error('trip-os-identity refused a wrong code without saying how many attempts are left');
            }
            codeCheck = { kind: 'wrong-code', attemptsLeft: refusal.attemptsLeft, secondsUntilResend };
        }
        else {
            codeCheck = { kind: refusal.reason, secondsUntilResend };
        }
        return codeCheck;
    }
}
//# sourceMappingURL=SignInService.js.map